<template>
  <div id="Communication">
    <el-row>
<!--      <el-col :span="8">-->
<!--        <img-->
<!--          width="250px"-->
<!--          src="@/assets/img/meeting and award/学术会议-1.png"-->
<!--        />-->
<!--        <div class="imgIntro">冯文卿博士，2018年北京，ISPRS报告</div>-->
<!--        <br/>-->
<!--        <img-->
<!--          width="250px"-->
<!--          src="@/assets/img/meeting and award/学术会议-2.png"-->
<!--        />-->
<!--        <div class="imgIntro">冯文卿博士，2016年捷克，ISPRS Poster</div>-->
<!--        <br/>-->
<!--        <img-->
<!--          width="250px"-->
<!--          src="@/assets/img/meeting and award/学术会议-6.jpg"-->
<!--        />-->
<!--        <div class="imgIntro">周明婷博士，2019年日本横滨，IGARSS2019</div>-->
<!--        <br/>-->
<!--        <img-->
<!--          width="250px"-->
<!--          src="@/assets/img/meeting and award/学术会议-5.png"-->
<!--        />-->
<!--        <div class="imgIntro">付宏博硕士，2017年俄罗斯，3s夏令营</div>-->
<!--      </el-col>-->
      <el-col :span="12">
        <img
          width="340px"
          src="@/assets/img/meeting and award/王斌杜卓童.jpg"
        />
        <div class="imgIntro">王斌博士和杜卓童博士，2024年希腊，IGARSS 2024</div>

        <br/>
        <img
          width="340px"
          src="@/assets/img/meeting and award/学术会议-6.jpg"
        />
        <div class="imgIntro">周明婷博士，2019年日本，IGARSS 2019</div>
        <br/>
        <img
          width="340px"
          src="@/assets/img/meeting and award/学术会议-1.png"
        />
        <div class="imgIntro">冯文卿博士，2018年中国北京，ISPRS报告</div>
        <br/>
        <img
          width="340px"
          src="@/assets/img/meeting and award/学术会议-5.png"
        />
        <div class="imgIntro">付宏博硕士，2017年俄罗斯，3s夏令营</div>
      </el-col>
      <el-col :span="12">
        <img
          width="340px"
          src="@/assets/img/meeting and award/王金地1.jpg"
        />
        <div class="imgIntro">王金地博士，2023年埃及，ISPRS报告</div>
      
        <br/>
        <img
          width="340px"
          src="@/assets/img/meeting and award/学术会议-3.png"
        />
        <div class="imgIntro">宋志娜博士，2018年西班牙，IGARSS Poster</div>

        <br/>
        <img
          width="340px"
          src="@/assets/img/meeting and award/学术会议-2.png"
        />
        <div class="imgIntro">冯文卿博士，2016年捷克，ISPRS Poster</div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang='less' scoped>
#Communication {
  margin: 20px 0;
  .imgIntro{
    font-size: 14px;
    color: #4f4f4f;
  }
}
</style>
